import { envApis } from "./env.api";
import productionEnv from "./env.prod";
import devEnv from "./env.dev";
const env = process.env.NODE_ENV === "production" ? productionEnv : devEnv;
export const environment = {
  ...envApis,
  ...env,
  paymentLinkService: { service: "payment-link" },
  paymentService: { service: "payment-service" },
};

export default environment;
